const API = process.env.REACT_APP_BACKEND_URL;

export const getToken = () => localStorage.getItem("pcf_session") || "";

export const setToken = (t) => {
    if (t) localStorage.setItem("pcf_session", t);
    else localStorage.removeItem("pcf_session");
};

export async function api(path, { method = "GET", body } = {}) {
    const res = await fetch(`${API}/api${path}`, {
        method,
        headers: {
            "Content-Type": "application/json",
            ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
        },
        credentials: "include",
        body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.detail || "Request failed");
    return data;
}

export const fetchMe = () => api("/auth/me");

export const getFleetPass = () => JSON.parse(localStorage.getItem("pcf_fleet_pass") || "null");

export const setFleetPass = (p) => {
    if (p) localStorage.setItem("pcf_fleet_pass", JSON.stringify(p));
    else localStorage.removeItem("pcf_fleet_pass");
};
